import { render, staticRenderFns } from "./register-user.vue?vue&type=template&id=adafe052&scoped=true&lang=pug&"
import script from "./register-user.vue?vue&type=script&lang=ts&"
export * from "./register-user.vue?vue&type=script&lang=ts&"
import style0 from "./register-user.vue?vue&type=style&index=0&id=adafe052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adafe052",
  null
  
)

export default component.exports